import StatisticCard from "./StatisticCard";
import { getLang } from "../../../store/uiStore";
import SectionCard from "../components/common/SectionCard";

export default function OverviewSection({ data }) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Общая информация" : "Маълумоти умумӣ",
        clinics: lang === "ru" ? "Всего клиник" : "Ҳамагӣ муассисаҳо",
        reports: lang === "ru" ? "Всего отчетов" : "Ҳамагӣ ҳисоботҳо",
    };

    if (!data) {
        return null;
    }

    return (

        <SectionCard

            title={tr.section}

            icon="bar-chart-line"

        >

            <div className="row g-3">

                <div className="col-lg-6">

                    <StatisticCard
                        title={tr.clinics}
                        value={data.total_clinics}
                    />

                </div>

                <div className="col-lg-6">

                    <StatisticCard
                        title={tr.reports}
                        value={data.total_reports}
                    />

                </div>

            </div>

        </SectionCard>

    );

}
